module.exports = __webpack_public_path__ + "73396e1206b445ec2babd85b2efc5d91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/people.png
// module id = 220
// module chunks = 0